import Button from 'components/Button';
import FormActions from 'components/Form/FormActions';
import FormResult from 'components/Form/FormResult';
import HeaderBasic from 'components/Headers/Basic';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {Backend} from 'types/api';
import {onApiError} from 'utils/request-axios/utils';

import PortalNotification, {
    MessageKind,
} from '../components/PortalNotification';
import PortalPageLayout from '../components/PortalPageLayout';
import {useAcceptPortalLogin} from './services';

export type AcceptPortalLoginBackend = Backend<{
    message?: MessageKind;
    next: string;
    token: string;
}>;

const AcceptPortalLogin = () => {
    const {data} = useBackend<AcceptPortalLoginBackend>();

    const methods = useForm();

    const acceptApi = useAcceptPortalLogin();

    const handleSubmit = async () => {
        await acceptApi
            .mutateAsync({next: data.next, token: data.token})
            .catch(onApiError(methods));
    };

    return (
        <PortalPageLayout isResponsive={true}>
            <HeaderBasic
                className="px-8 pb-2"
                dropdownLocaleSize="xs"
                showSignIn={false}
            />
            <div className="flex w-full flex-col gap-y-4 px-8">
                <PortalNotification kind={data.message} />
                <div className="rounded-lg border border-grey-300 bg-white px-6 pb-12 pt-6 shadow-lg">
                    <FormProvider {...methods}>
                        <form onSubmit={methods.handleSubmit(handleSubmit)}>
                            <h1 className="mt-2">{t`Welcome to Business Portals by MakeLeaps`}</h1>
                            <p className="my-2 text-base">
                                {t`We noticed this is the first time you’re using this browser to access Business Portals. Please click Proceed to continue.`}
                            </p>
                            <FormActions className="mt-2">
                                <Button
                                    disabled={acceptApi.isLoading}
                                    isLoading={acceptApi.isLoading}
                                    type="submit"
                                >{t`Proceed`}</Button>
                            </FormActions>
                            <FormResult className="mt-4" />
                        </form>
                    </FormProvider>
                </div>
            </div>
        </PortalPageLayout>
    );
};

export default AcceptPortalLogin;
